<template>
  <div class="modal-wrapper">
    <div class="modal-dialog extra-large-modal" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Detalhes do parcelamento
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <div class="panel__row">
            <div class="panel__col">
              <p class="panel__title">
                Dias para começar a cobrar
              </p>
              <p>{{ debt.days_to_start_charging }} dias após o término do curso</p>
            </div>
            <div class="panel__col">
              <p class="panel__title">
                Saldo devedor
              </p>
              <p>{{ debt.student_debt | formatCurrency }}</p>
            </div>
            <div class="panel__col">
              <p class="panel__title">
                Quantidade de mensalidades após curso
              </p>
              <p>{{ debt.installments_after_course }}</p>
            </div>
          </div>
          <div class="panel__row">
            <div class="panel__col">
              <div class="panel panel-primary contract__panel">
                <button
                  class="btn btn-default contract-list__expand-btn collapsed"
                  data-toggle="collapse"
                  :aria-expanded="true"
                  :data-target="`#installment-rules-tab-${billing.id}`"
                >
                  <span>
                    <span>
                      <strong>Forma de Pagamento</strong>
                    </span>
                  </span>
                  <span class="colalapse--opened glyphicon glyphicon-menu-up" aria-hidden="true"></span>
                  <span class="colalapse--closed glyphicon glyphicon-menu-down" aria-hidden="true"></span>
                </button>
                <div :id="`installment-rules-tab-${billing.id}`" :aria-expanded="true" class="collapse in">
                  <div class="table-responsive">
                    <table class="table table-hover table-spaced">
                      <thead>
                        <tr>
                          <th>% Durante o curso</th>
                          <th>% Após o curso</th>
                          <th>Válido de</th>
                          <th>Válido até</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(rule, index) in debt.installment_rules" :key="index">
                          <td>{{ rule.during_course_percentage }}%</td>
                          <td>{{ rule.after_course_percentage }}%</td>
                          <td>{{ rule.valid_from | formatDate }}</td>
                          <td>{{ rule.valid_until | formatDate }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel__row">
            <div class="panel__col">
              <div class="panel panel-primary contract__panel">
                <button
                  class="btn btn-default contract-list__expand-btn"
                  data-toggle="collapse"
                  :aria-expanded="true"
                  :data-target="`#installment-tab-${billing.id}`"
                >
                  <span>
                    <span>
                      <strong>Descrição do saldo devedor</strong>
                    </span>
                  </span>
                  <span class="colalapse--opened glyphicon glyphicon-menu-up" aria-hidden="true"></span>
                  <span class="colalapse--closed glyphicon glyphicon-menu-down" aria-hidden="true"></span>
                </button>
                <div :id="`installment-tab-${billing.id}`" :aria-expanded="true" class="collapse in">
                  <div class="table-responsive">
                    <table class="table table-hover table-spaced">
                      <thead>
                        <tr>
                          <th>Origem</th>
                          <th>Valor durante o curso</th>
                          <th>Valor Depois do curso</th>
                          <th>Valor total</th>
                          <th>Data de vencimento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(quota, index) in debt.debt_description" :key="index">
                          <td>{{ quota.origin_id }} # {{ quota.origin_type }}</td>
                          <td>{{ quota.during_course_amount | formatCurrency }}</td>
                          <td>{{ quota.after_course_amount | formatCurrency }}</td>
                          <td>{{ quota.full_amount | formatCurrency }}</td>
                          <td>{{ quota.due_date | formatDate }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParcelamentoService from 'services/ParcelamentoService';

export default {
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      debt: {},
    };
  },
  created() {
    if (!this.billing.installment) {
      ParcelamentoService.getInstallmentDebts(this.billing.id)
        .then((installment) => {
          this.debt = installment;
          this.$emit('installment-loaded', installment);
        })
        .catch(() => {
          this.$emit('close');
        });
    } else {
      this.debt = this.billing.installment;
    }
  },
};
</script>
